import { useMemo } from "react";
import { useLocation } from "react-router-dom";

const WASHOUT_REVIEW_FRAGMENT = "washout-review";

export const useIsWashoutReview = (): boolean => {
	const { pathname } = useLocation();

	return useMemo(() => {
		const segments = pathname?.toLowerCase().split("/").filter(Boolean);
		return segments.includes(WASHOUT_REVIEW_FRAGMENT);
	}, [pathname]);
};
